/* - - - - - - - - - - - - - -       open fancybox link       - - - - - - - - - - - - - - - */
function initFancyboxLink( link ) {
	$.fancybox.open({
		src: link,
		closeExisting: true,
		animationEffect: 'fade',
		touch: false,
		autoFocus: false,
		buttons: [
			'slideShow',
			'close'
		],
		smallBtn: true,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close-rect"></span>' +
				'</button>'
		}
	});
}

$( document ).ready( function() {

	/* - - - - - - - - - - - - - -       init inputmask       - - - - - - - - - - - - - - - */
	// $( '[type="tel"]' ).inputmask( '+38 (999) 999 99 99' );

	/* - - - - - - - - - - - - - -       init slick       - - - - - - - - - - - - - - - */
	// $( '.js-slider' ).slick({
	// 	infinite: false,
	// 	arrows: true,
	// 	dots: false,
	// 	slidesToScroll: 1,
	// 	slidesToShow: 2
	// });

	/* - - - - - - - - - - - - - -       init fancybox       - - - - - - - - - - - - - - - */
	$( '[data-fancybox]' ).fancybox({
		closeExisting: true,
		animationEffect: 'fade',
		touch: false,
		autoFocus: false,
		buttons: [
			'slideShow',
			'close'
		],
		smallBtn: true,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close-rect"></span>' +
				'</button>'
		}
	});

	/* - - - - - - - - - - - - - -       init fancybox video       - - - - - - - - - - - - - - - */
	$( '[data-fancybox-video]' ).fancybox({
		slideClass: 'modal-video',
		video: {
			tpl:
				'<video class="fancybox-video" autoplay playsinline muted loop="loop" controls controlsList="nodownload" poster="{{poster}}">' +
					'<source src="{{src}}" type="{{format}}" />' +
					'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
				'</video>',
			format: '', // custom video format
			autoStart: true
		},
		smallBtn: false,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close-rect"></span>' +
				'</button>'
		},
		scrolling: 'hidden',
		helpers: {
			overlay: {
				locked: true
			}
		},
		beforeShow: function() {
			$( 'body' ).css({ 'overflow-y': 'hidden' });
		},
		afterClose: function() {
			$( 'body' ).css({ 'overflow-y': 'visible' });
		}
	});

	/* - - - - - - - - - - - - - -       input file       - - - - - - - - - - - - - - - */
	function showFileError( $this, mess ) {
		$this.find( '.js-file [type="file"]' ).val( '' );
		$this.find( '.file-box__status' ).text( mess );
	}
	$( document ).on( 'change', '.js-file [type="file"]', function( e ) {
		const $this = $( this );
		const $parent = $this.closest( '.file-box' );
		const list = $this[ 0 ].files;
		const errorType = $this.attr( 'data-error-type' ) ? $this.attr( 'data-error-type' ) : 'Error';
		const errorSize = $this.attr( 'data-error-size' ) ? $this.attr( 'data-error-size' ) : 'Error';
		const textSuccess = $this.attr( 'data-success' ) ? $this.attr( 'data-success' ) : 'Success';
		const textError = $this.attr( 'data-error' ) ? $this.attr( 'data-error' ) : 'Error';
		let isError = false;
		$parent.removeClass( 'has-success, has-error' );
		$parent.find( '.file-box__status' ).text( '' );
		// $this.closest( '.file-box' ).find( '.file-box__list-box' ).remove();
		for ( let i = 0; i < list.length; i++ ) {
			const name = list[ i ].name;
			let size = 5000; // size of kb
			// let fileBoxTpl = '';

			// validate type file
			const typeFileArr = $this.attr( 'accept' ).split( ',' );
			if ( !typeFileArr.includes( '.' + name.slice( -5 ).split( '.' )[ 1 ].toLowerCase() ) ) {
				isError = true;
				$parent.addClass( 'has-error' );
				showFileError( $parent, textError );
				return false;
			}

			// validate size file
			if ( $this.attr( 'data-size' ) && $this.attr( 'data-size' ) !== '' ) {
				size = parseInt( $this.attr( 'data-size' ) );
			}
			if ( size < list[ i ].size / 1000 ) {
				isError = true;
				$parent.addClass( 'has-error' );
				showFileError( $parent, textError );
				return false;
			}

			if ( !isError ) {
				$parent.addClass( 'has-success' );
				showFileError( $parent, textSuccess );
			}

			// fileBoxTpl =
			// 	'<div class="file-box__list-box">' +
			// 		'<div class="file-box__list-box-name">' +
			// 			name +
			// 		'</div>' +
			// 		'<div class="file-box__delete js-file-delete">' +
			// 			'<span class="icon icon-i-close"></span>' +
			// 		'</div>' +
			// 	'</div>';
			// $parent.find( '.file-box__list' ).append( fileBoxTpl );
		}
	});
	// $( document ).on( 'click', '.js-file-delete', function() {
	// 	const $this = $( this ),
	// 		$parent = $this.closest( '.form-group' );
	// 	$this.remove();
	// 	$parent.removeClass( 'filled' );
	// 	$parent.find( '.file-box__list-box' ).remove();
	// 	$parent.find( '[type="file"]' ).val( '' );
	// });

	/* - - - - - - - - - - - - - -       dropdown toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-dropdown', function() {
		const $parent = $( this ).closest( '.dropdown' ),
			$list = $parent.find( '.dropdown-list' );
		if ( !$parent.hasClass( 'show' ) ) {
			$( '.dropdown' ).removeClass( 'show' );
			$( '.dropdown-list' ).slideUp( 500 );
			$parent.addClass( 'show' );
			$list.slideDown( 500 );
		} else {
			$parent.removeClass( 'show' );
			$list.slideUp( 500 );
		}
	});
	$( document ).on( 'click', '.dropdown-list li', function() {
		const $this = $( this ),
			$parent = $this.closest( '.dropdown' ),
			$list = $parent.find( '.dropdown-list' );
		$parent.removeClass( 'show' );
		$list.slideUp( 500 );
		if ( !$this.hasClass( 'active' ) ) {
			$list.find( 'li' ).removeClass( 'active' );
			$this.addClass( 'active' );
		}
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.top-order' ).length ) {
			return;
		}
		$( '.top-order' ).removeClass( 'active' );
		$( '.top-order .orders-fast' ).removeClass( 'active' );
		$( '.dark_overlay' ).removeClass( 'active' );
	});

	/* - - - - - - - - - - - - - -       rebuild header       - - - - - - - - - - - - - - - */
	$( '.header' ).addClass( 'loaded' );
	function rebuildHeader() {
		const $slogan = $( '.header .slogan' ).detach(),
			$contacts = $( '.header-contacts' ).detach(),
			$socials = $( '.header-socials' ).detach(),
			$feedback = $( '.header-feedback' ).detach();
		if ( window.matchMedia( '(min-width:1240px)' ).matches ) {
			$( '.header-left' ).append( $slogan );
			$( '.header-left' ).after( $contacts );
			$( '.header-right' ).prepend( $feedback );
			$( '.header-right' ).prepend( $socials );
		} else {
			$( '.header-mobile' ).append( $slogan );
			$( '.top-menu' ).after( $socials );
			$( '.top-menu' ).after( $contacts );
			$( '.top-menu' ).after( $feedback );
		}
	}
	if ( $( '.header' ).length ) {
		rebuildHeader();
		$( window ).on( 'resize', function() {
			rebuildHeader();
		});
	}

	/* - - - - - - - - - - - - - -       function disable scroll page       - - - - - - - - - - - - - - - */
	function disableScrollPage( action = false ) {
		if ( action ) {
			$( 'body' ).addClass( 'fixed' );
		} else {
			$( 'body' ).removeClass( 'fixed' );
		}
	}

	/* - - - - - - - - - - - - - -       header toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-menu-toggle', function() {
		$( '.header' ).addClass( 'show' );
		disableScrollPage( true );
	});
	$( document ).on( 'click', '.js-header-close, .header-overlay', function() {
		$( '.header' ).removeClass( 'show' );
		disableScrollPage( false );
	});

	/* - - - - - - - - - - - - - -       set submenu position       - - - - - - - - - - - - - - - */
	function setPosSubmenu() {
		if ( window.matchMedia( '(min-width: 1240px)' ).matches ) {
			$( '.submenu' ).css( 'display', '' );
			// $( '.submenu' ).each( function() {
			// 	const $this = $( this ),
			// 		$box = $this.find( '.submenu-box' ),
			// 		$parent = $this.closest( 'li' );
			// 	let posLeft = 0;
			// 	posLeft = ( $box.find( 'ul:first-child' ).innerWidth() - $parent.innerWidth() ) / 2 + parseInt( $box.css( 'padding-left' ) );
			// 	if ( $this.find( '.sub-menu' ).length ) {
			// 		posLeft = ( 210 - $parent.innerWidth() ) / 2 + parseInt( $box.css( 'padding-left' ) );
			// 	}
			// 	$this.css( 'left', '-' + parseInt( posLeft ) + 'px' );
			// });
		} else {
			$( '.submenu' ).css( 'left', '' );
		}
	}
	setPosSubmenu();
	$( window ).on( 'resize', setPosSubmenu );

	/* - - - - - - - - - - - - - -       submenu toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-submenu', function() {
		const $parent = $( this ).closest( 'li' );
		if ( !$parent.hasClass( 'show' ) ) {
			$parent.addClass( 'show' );
			$parent.find( '.submenu' ).slideDown( 500 );
		} else {
			$parent.removeClass( 'show' );
			$parent.find( '.submenu' ).slideUp( 500 );
		}
	});

	// $( document ).on( 'click', '.top-menu a', function( e ) {
	// 	const $this = $( this ),
	// 		$parent = $this.closest( 'li' );
	// 	if ( $parent.find( '.submenu' ).length ) {
	// 		e.preventDefault();
	// 		if ( !$parent.hasClass( 'show' ) ) {
	// 			$parent.addClass( 'show' );
	// 			$parent.find( '.submenu' ).slideDown( 500 );
	// 		} else {
	// 			$parent.removeClass( 'show' );
	// 			$parent.find( '.submenu' ).slideUp( 500 );
	// 		}
	// 	}
	// });

	function scrollMobileHeader() {
		if ( window.matchMedia( '(max-width: 1239px)' ).matches ) {
			let time = 0;
			const scrollHeader = setInterval( function() {
				$( '.header-inner' ).animate({ scrollTop: 10000 + 'px' }, 10 );
				time += 10;
				if ( time >= 500 ) {
					clearInterval( scrollHeader );
				}
			}, time );
		}
	}

	/* - - - - - - - - - - - - - -       toggle header search       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-header-search', function() {
		$( this ).closest( '.header-search' ).toggleClass( 'show' );
		scrollMobileHeader();
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.header-search' ).length ) {
			return;
		}
		$( '.header-search' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       toggle header lang       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-header-lang', function() {
		$( this ).closest( '.header-lang' ).toggleClass( 'show' );
		scrollMobileHeader();
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.header-lang' ).length ) {
			return;
		}
		$( '.header-lang' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       industry tabs       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.main-industry__tabs li', function() {
		const $this = $( this );
		if ( !$this.hasClass( 'active' ) ) {
			$( '.main-industry__tabs li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$( '.main-industry__box' ).removeClass( 'show' );
			$( '.main-industry__box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).addClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       init partners slider       - - - - - - - - - - - - - - - */
	function initPartnersSlider( $partnersSlider, count ) {
		$partnersSlider.owlCarousel({
			loop: ( count > 3 ),
			nav: true,
			dots: false,
			smartSpeed: 600,
			items: 3,
			slideBy: 1,
			margin: 15,
			navText: [
				'<span class="icon icon-i-arr-left"></span>',
				'<span class="icon icon-i-arr-right"></span>'
			],
			responsive: {
				575: {
					loop: ( count > 4 ),
					items: 4,
					margin: 15
				},
				768: {
					loop: ( count > 4 ),
					items: 4,
					margin: 20
				},
				992: {
					loop: ( count > 5 ),
					items: 5,
					margin: 30
				},
				1240: {
					loop: ( count > 6 ),
					items: 6,
					margin: 30
				},
				1440: {
					loop: ( count > 6 ),
					items: 6,
					margin: 40
				}
			}
		});
	}
	$( '.js-partners-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initPartnersSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       init map       - - - - - - - - - - - - - - - */
	let mapZoomDefault = 0,
		mapZoom = 0;
	function initMap() {
		const $scroll = $( '.main-map__scroll' ),
			$map = $( '.main-map__box' ),
			$mapImg = $( '.main-map__box-img' );
		$map.css( 'width', '' );
		$mapImg.css({
			'width': 'auto',
			'height': 'auto'
		});
		const scrollWidth = $scroll.innerWidth(),
			scrollHeight = $scroll.innerHeight(),
			ds = scrollWidth / scrollHeight,
			mapWidth = $mapImg.innerWidth(),
			mapHeight = $mapImg.innerHeight(),
			dm = mapWidth / mapHeight;
		// $map.find( '.map-point' ).each( function() {
		// 	const x = parseInt( $( this ).css( 'left' ) ),
		// 		y = parseInt( $( this ).css( 'top' ) );
		// 	let posX = x * 100 / mapWidth,
		// 		posY = y * 100 / mapHeight;
		// 	$( this ).css({
		// 		'left': posX + '%',
		// 		'top': posY + '%'
		// 	});
		// });

		let setWidth = 100,
			newWidth = 0,
			newHeight = 0;
		if ( ds > dm ) {
			$map.css( 'width', setWidth + '%' );
			$mapImg.css( 'width', '100%' );
			newHeight = $map.innerHeight();
			$scroll.animate({ scrollTop: ( newHeight - scrollHeight ) / 2 + 'px' }, 0 );
		} else {
			setWidth = mapWidth / ( mapHeight / scrollHeight ) * 100 / scrollWidth;
			$map.css( 'width', setWidth + '%' );
			$mapImg.css( 'width', '100%' );
			newWidth = $map.innerWidth();
			$scroll.animate({ scrollLeft: ( newWidth - scrollWidth ) / 2 + 'px' }, 0 );
		}
		mapZoom = setWidth;
		mapZoomDefault = setWidth;
		$( '.map-point' ).show( 0 );
	}
	if ( $( '.js-map' ).length ) {
		$( '.main-map__box img' ).one( 'load', function() {
			initMap();
			$( window ).on( 'resize', initMap );
		}).each( function() {
			if ( this.complete ) {
				$( this ).trigger( 'load' );
			}
		});
	}

	/* - - - - - - - - - - - - - -       map zoom in/out       - - - - - - - - - - - - - - - */
	function zoomMap( action ) {
		const $map = $( '.main-map__box' );
		let zoomMin = mapZoomDefault,
			zoomMax = mapZoomDefault + 100;
		if ( action === 'in' ) {
			if ( mapZoom < zoomMax ) {
				mapZoom += 10;
			}
		}
		if ( action === 'out' ) {
			if ( mapZoom > zoomMin ) {
				mapZoom -= 10;
			}
		}
		$map.css( 'width', mapZoom + '%' );
	}
	$( document ).on( 'click', '.js-zoom-in', function() {
		zoomMap( 'in' );
	});
	$( document ).on( 'click', '.js-zoom-out', function() {
		zoomMap( 'out' );
	});

	/* - - - - - - - - - - - - - -       map scroll       - - - - - - - - - - - - - - - */
	if ( $( '.main-map__box' ).length ) {
		$( '.main-map__box' ).on( 'mousemove', function( e ) {
			const moveX = Math.abs( e.originalEvent.movementX ),
				moveY = Math.abs( e.originalEvent.movementY );
			if ( window.matchMedia( '(hover: hover)' ).matches ) {
				const $mapScroll = $( this ).closest( '.main-map__scroll' );
				if ( e.buttons ) {
					if ( e.originalEvent.movementX < 0 ) {
						$mapScroll.stop().animate({ scrollLeft: '+=' + moveX + 'px' }, 0 );
					}
					if ( e.originalEvent.movementX > 0 ) {
						$mapScroll.stop().animate({ scrollLeft: '-=' + moveX + 'px' }, 0 );
					}
					if ( e.originalEvent.movementY < 0 ) {
						$mapScroll.stop().animate({ scrollTop: '+=' + moveY + 'px' }, 0 );
					}
					if ( e.originalEvent.movementY > 0 ) {
						$mapScroll.stop().animate({ scrollTop: '-=' + moveY + 'px' }, 0 );
					}
				}
			}
		});
	}

	/* - - - - - - - - - - - - - -       map show info       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-marker', function() {
		const $map = $( this ).closest( '.main-map__box' ),
			$parent = $( this ).closest( '.map-point' ),
			$info = $parent.find( '.map-point__modal' ),
			posX = $parent.position().left;
		let direction = posX + 260 > $map.innerWidth() ? 'left' : 'right';
		$( '.map-point' ).removeClass( 'show' );
		$parent.addClass( 'show' );
		$info.removeClass( 'left, right' ).addClass( direction );
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.map-point' ).length ) {
			return;
		}
		$( '.map-point' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       catalog toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-catalog-sidebar', function() {
		const $this = $( this ),
			$parent = $this.closest( '.catalog-sidebar__box' );
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			if ( !$parent.hasClass( 'show' ) ) {
				$( '.catalog-sidebar__box' ).removeClass( 'show' );
				$parent.addClass( 'show' );
				$( '.catalog-sidebar__box-list' ).slideUp( 500 );
				$parent.find( '.catalog-sidebar__box-list' ).slideDown( 500 );
			} else {
				$parent.removeClass( 'show' );
				$parent.find( '.catalog-sidebar__box-list' ).slideUp( 500 );
			}
		}
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.catalog-sidebar__box' ).length ) {
			return;
		}
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			$( '.catalog-sidebar__box' ).removeClass( 'show' );
			$( '.catalog-sidebar__box-list' ).slideUp( 500 );
		}
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
			$( '.catalog-sidebar__box' ).removeClass( 'show' );
			$( '.catalog-sidebar__box-list' ).css( 'display', '' );
		}
	});

	/* - - - - - - - - - - - - - -       pagination mobile       - - - - - - - - - - - - - - - */
	function showPagination() {
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			const indexActive = $( '.pagination li.active' ).index(),
				count = $( '.pagination li' ).length,
				countVisible = 3;
			$( '.pagination li' ).css( 'display', '' );
			if ( indexActive === 1 ) {
				for ( let i = indexActive; i < indexActive + countVisible; i++ ) {
					$( '.pagination li' ).eq( i ).show( 0 );
				}
			} else if ( indexActive === count - 2 ) {
				for ( let i = indexActive; i > indexActive - countVisible; i-- ) {
					$( '.pagination li' ).eq( i ).show( 0 );
				}
			} else {
				for ( let i = indexActive; i < indexActive + countVisible; i++ ) {
					$( '.pagination li' ).eq( i - 1 ).show( 0 );
				}
			}
		} else {
			$( '.pagination li' ).css( 'display', '' );
		}
	}
	if ( $( '.pagination' ).length ) {
		showPagination();
		$( window ).on( 'resize', showPagination );
	}

	/* - - - - - - - - - - - - - -       description tabs       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-description-tabs li', function() {
		const $this = $( this );
		if ( !$this.hasClass( 'active' ) ) {
			$( '.product-description__tabs li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$( '.product-description__box' ).removeClass( 'show' );
			$( '.product-description__box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).addClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       table wrap       - - - - - - - - - - - - - - - */
	$( '.text table' ).each( function() {
		$( this ).wrap( '<div class="table-box">' ).wrap( '<div class="table-responsive">' );
	});

	/* - - - - - - - - - - - - - -       toggle lang       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-lang', function() {
		const $parent = $( this ).closest( '.lang' );
		if ( !$parent.hasClass( 'show' ) ) {
			$( '.lang' ).removeClass( 'show' );
			$parent.addClass( 'show' );
		} else {
			$parent.removeClass( 'show' );
		}
	});
	$( document ).on( 'click', '.lang li', function() {
		const $this = $( this ),
			$parent = $this.closest( '.lang' ),
			$title = $parent.find( '.lang-title span:not(.icon)' );
		$parent.removeClass( 'show' );
		$parent.find( 'li' ).removeClass( 'active' );
		$this.addClass( 'active' );
		$title.text( $this.text() );
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.lang' ).length ) {
			return;
		}
		$( '.lang' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       init product gallery slider       - - - - - - - - - - - - - - - */
	const $productGallerySlider = $( '.js-product-gallery-slider' );
	$productGallerySlider.children().each( function( index ) {
		$( this ).attr( 'data-position', index );
	});
	$productGallerySlider.owlCarousel({
		loop: false,
		nav: true,
		dots: false,
		smartSpeed: 600,
		items: 1,
		slideBy: 1,
		margin: 0,
		navText: [
			'<span class="icon icon-i-arr-left"></span>',
			'<span class="icon icon-i-arr-right"></span>'
		],
		onInitialized: function() {
			$( '.product-details__gallery-thumb .product-details__gallery-box:first-child' ).addClass( 'active' );
		},
		onChanged: function() {
			setTimeout( function() {
				const index = $( '.product-details__gallery-slider .owl-item.active .product-details__gallery-box' ).attr( 'data-position' );
				$( '.product-details__gallery-thumb .product-details__gallery-box' ).removeClass( 'active' );
				$( '.product-details__gallery-thumb .product-details__gallery-box' ).eq( index ).addClass( 'active' );
			}, 100 );
		}
	});
	$( document ).on( 'click', '.product-details__gallery-thumb .product-details__gallery-box', function() {
		const index = $( this ).index();
		$productGallerySlider.trigger( 'to.owl.carousel', [ index, 600 ] );
	});

	/* - - - - - - - - - - - - - -       faq toggle       - - - - - - - - - - - - - - - */
	if ( $( '.faq-box' ).length ) {
		$( '.faq-box' ).each( function() {
			if ( $( this ).hasClass( 'show' ) ) {
				$( this ).find( '.faq-box__body' ).slideDown( 500 );
			}
		});
	}
	$( document ).on( 'click', '.js-faq', function() {
		const $parent = $( this ).closest( '.faq-box' );
		if ( !$parent.hasClass( 'show' ) ) {
			$( '.faq-box' ).removeClass( 'show' );
			$parent.addClass( 'show' );
			$( '.faq-box__body' ).stop().slideUp( 500 );
			$parent.find( '.faq-box__body' ).stop().slideDown( 500 );
			setTimeout( function() {
				$( 'html, body' ).stop().animate({ scrollTop: $parent.offset().top - $( '.header' ).innerHeight() + 'px' }, 500 );
			}, 500 );
		} else {
			$parent.removeClass( 'show' );
			$parent.find( '.faq-box__body' ).stop().slideUp( 500 );
		}
	});

	/* - - - - - - - - - - - - - -       collapse toggle       - - - - - - - - - - - - - - - */
	if ( $( '.collapse_item' ).length ) {
		$( '.collapse_item' ).each( function() {
			if ( $( this ).hasClass( 'show' ) ) {
				$( this ).find( '.collapse_content' ).slideDown( 500 );
			}
		});
	}
	$( document ).on( 'click', '.collapse_toggle', function() {
		const $parent = $( this ).closest( '.collapse_item' );
		if ( !$parent.hasClass( 'show' ) ) {
			$( '.collapse_item' ).removeClass( 'show' );
			$parent.addClass( 'show' );
			$( '.collapse_content' ).stop().slideUp( 500 );
			$parent.find( '.collapse_content' ).stop().slideDown( 500 );
		} else {
			$parent.removeClass( 'show' );
			$parent.find( '.collapse_content' ).stop().slideUp( 500 );
		}
	});

	/* - - - - - - - - - - - - - -       init team slider       - - - - - - - - - - - - - - - */
	function initTeamSlider( $teamSlider, count ) {
		$teamSlider.owlCarousel({
			// loop: true,
			loop: ( count > 2 ),
			nav: true,
			dots: false,
			smartSpeed: 600,
			items: 2,
			slideBy: 1,
			margin: 20,
			navText: [
				'<span class="icon icon-i-arr-left"></span>',
				'<span class="icon icon-i-arr-right"></span>'
			],
			responsive: {
				575: {
					loop: ( count > 3 ),
					items: 3,
					margin: 20
				},
				768: {
					loop: ( count > 3 ),
					items: 3,
					margin: 28
				},
				992: {
					loop: ( count > 3 ),
					items: 3,
					margin: 35
				},
				1240: {
					loop: ( count > 4 ),
					items: 4,
					margin: 35
				}
			}
		});
	}
	$( '.js-team-slider' ).each( function() {
		const $this = $( this ),
			count = $this.find( '> *' ).length;
		initTeamSlider( $this, count );
	});

	/* - - - - - - - - - - - - - -       toggle list file option       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-list-file-option', function() {
		const $parent = $( this ).closest( '.list-file__box-option' );
		if ( !$parent.hasClass( 'show' ) ) {
			$( '.list-file__box-option' ).removeClass( 'show' );
			$parent.addClass( 'show' );
		} else {
			$parent.removeClass( 'show' );
		}
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.list-file__box-option' ).length ) {
			return;
		}
		$( '.list-file__box-option' ).removeClass( 'show' );
	});
});
